/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import Tick from "./Tick";

// todo: suggest based on utilization

export default class DiagCodeSelect extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            diagCodes: []
        }
    }

    search = (e) => {
        if (!e.target.value) {
            this.setState({ diagCodes: [] });
            return;
        }
        qreq.post('/api/diagcode/list', { search: e.target.value }, j => {
            if (this.state.touched)
                return;
            if (j.list)
                this.setState({ diagCodes: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    change = (e) => {
        this.setState({ touched: true, search: e.target.value });
    }

    tick = () => {
        if (this.state.touched) {
            this.setState({ touched: false });
            this.search({ target: { value: this.state.search } });
        }
    }

    select(i) {
        if (this.isSelected(i)) {
            this.props.item.diagCodes = this.props.item.diagCodes.filter(j => j.id !== i.id);
        } else {
            this.props.item.diagCodes = this.props.item.diagCodes ?? [];
            this.props.item.diagCodes.push(i);
        }
        this.props.onChange?.(i);
    }

    isSelected(i) {
        if (this.props.item?.diagCodes?.find(j => j.id === i.id))
            return true;
        return false;
    }

    render() {
        return <Card title={this.props.title || 'Diagnosis Codes'}>
            <Tick interval={1000} onTick={this.tick} />
            {!this.props.disabled && <input type="text" className="form-control mb-3" placeholder="Search diagnosis code or description..." onChange={this.change} />}
            {this.props.item?.diagCodes?.length === 0 ? <div className="text-muted"><L>No Diagnosis Codes Selected</L></div> : <table className="table">
                <thead>
                    <tr>
                        <th><L>DiagCode</L></th>
                        <th><L>Description</L></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.item?.diagCodes?.map((i, idx) => <tr key={idx}>
                        <td>{i.code}</td>
                        <td>{i.description}</td>
                        <td className="text-end">
                            {!this.props.disabled && <button type="button" className="btn-close" onClick={() => this.select(i)}></button>}
                        </td>
                    </tr>)}
                </tbody>
            </table>}
            {!this.props.disabled && this.state.diagCodes?.map((i, idx) => <div key={idx} className="border-bottom my-2">
                <div className="row align-items-center">
                    <div className="col-3 col-md-2 col-lg-2">
                        <button type="button" className={'btn w-100 ' + (this.isSelected(i) ? 'btn-success' : 'btn-primary')} onClick={() => this.select(i)}>{i.displayCode}</button>
                    </div>
                    <div className="col-9 col-md-10 col-lg-10">
                        {i.description}
                    </div>
                </div>
            </div>)}
        </Card>;
    }
}